module.exports = __webpack_public_path__ + "assets/faada70278ec5832663d5c9ec5f0cb00.svg";